module.exports = __webpack_public_path__ + "img/badge-science.89fe02f1.svg";